<template>
  <v-application>
    <v-layout>
      <v-flex md8>
        <v-card class="mb-3">
          {{name}}
        </v-card>
      </v-flex>
    </v-layout>
  </v-application>
</template>
<script>
export default {
  name: 'InventoryPrint',
  mounted(){

  },
  computed: {
    name(){
      const keys = Object.keys(this.$route.query) 
      if(keys.length > 0){
        return keys[0]
      }
      return null
    }
  }
}
</script>
